import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <>
      <Navbar />
      <main className="clean-sheen">
        <Home />
        <Contact />
        <Footer />
      </main>
    </>
  );
}
